import { render, staticRenderFns } from "./SelectedAddOns.vue?vue&type=template&id=d6d36f3a&scoped=true&"
import script from "./SelectedAddOns.vue?vue&type=script&lang=js&"
export * from "./SelectedAddOns.vue?vue&type=script&lang=js&"
import style0 from "./SelectedAddOns.vue?vue&type=style&index=0&id=d6d36f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6d36f3a",
  null
  
)

export default component.exports